/**
 * Omits properties from an object.
 *
 * @example
 * omit({ foo: 1, bar: 2 }, ['foo']) // => { bar: 2 }
 */
export function omit(x, ks) {
    var keys = Object.keys(x);
    var results = {};
    for (var i = 0; i < keys.length; i += 1) {
        var k = keys[i];
        if (!ks.includes(k))
            results[k] = x[k];
    }
    return results;
}
/**
 * Picks properties from an object.
 *
 * @example
 * pick({ foo: 1, bar: 2 }, ['foo']) // => { foo: 1 }
 */
export function pick(x, ks) {
    var keys = Object.keys(x);
    var results = {};
    for (var i = 0; i < keys.length; i += 1) {
        var k = keys[i];
        if (ks.includes(k))
            results[k] = x[k];
    }
    return results;
}
/**
 * Given an input object, this will return a new object with the same keys, but
 * the values mapped to the result of calling `iteratee` with each.
 *
 * @example
 * mapValues({ a: 2, b: 4 }, x => x * 2) // => { a: 4, b: 8 }
 */
export function mapValues(xs, iteratee) {
    var result = {};
    var keys = Object.keys(xs);
    for (var i = 0, k = void 0; i < keys.length; i += 1) {
        k = keys[i];
        result[k] = iteratee(xs[k], k, xs);
    }
    return result;
}
/**
 * Gets the number of items in an array or object.
 *
 * @example
 * size({ a: 2, b: 4 }) // => 2
 */
export function size(x) {
    return Array.isArray(x) ? x.length : Object.keys(x).length;
}
/**
 * Equivalent to `Object.fromEntries` for node versions that don't support it.
 *
 * @example
 * const pairs = [['a', 1], ['b', 2]]
 * const object = fromPairs(pairs)
 * // => { a: 1, b: 2 }
 */
export function fromPairs(pairs) {
    var result = {};
    for (var i = 0; i < pairs.length; i += 1) {
        // eslint-disable-next-line prefer-destructuring
        result[pairs[i][0]] = pairs[i][1];
    }
    return result;
}
//# sourceMappingURL=object.js.map